import { generateJsBasicsQuiz } from './javascript/jsBasicsQuiz';
import { generateJsFunctionsQuiz } from './javascript/jsFunctionsQuiz';
import { generateReactComponentsQuiz } from './react/reactComponentsQuiz';
import { generateK8sClusterArchitectureQuiz } from './kubernetes/k8sClusterArchitectureQuiz';
import { generateK8sNetworkingQuiz } from './kubernetes/k8sNetworkingQuiz';
import { generateVercelEdgeFunctionsQuiz } from './edge-computing/vercelEdgeFunctionsQuiz';
import { generateCloudflareWorkersQuiz } from './edge-computing/cloudflareWorkersQuiz';
import { generateUnityFundamentalsQuiz } from './game-development/unityFundamentalsQuiz';
import { generateUnityScriptingQuiz } from './game-development/unityScriptingQuiz';
import { generateSmartIotSystemsQuiz } from './iot/smartIotSystemsQuiz';
import { generateIotSecurityQuiz } from './iot/iotSecurityQuiz';
import { generatePerformanceMonitoringQuiz } from './performance/performanceMonitoringQuiz';
import { generateLoadTestingQuiz } from './performance/loadTestingQuiz';
import { generateRpaEnterpriseArchitectureQuiz } from './automation/rpaEnterpriseArchitectureQuiz';
import { generateRoboticsRlBasicsQuiz } from './robotics/roboticsRlBasicsQuiz';
import { generateAdvancedRlAlgorithmsQuiz } from './robotics/advancedRlAlgorithmsQuiz';
import { generateOwaspTestingQuiz } from './security/owaspTestingQuiz';

/**
 * Centralized registry for all missing module quizzes
 * Maps module IDs to their quiz generator functions
 */
export const MISSING_MODULE_QUIZZES: Record<string, () => any> = {
  'js-basics': generateJsBasicsQuiz,
  'js-functions': generateJsFunctionsQuiz,
  'react-components': generateReactComponentsQuiz,
  'k8s-cluster-architecture': generateK8sClusterArchitectureQuiz,
  'k8s-networking': generateK8sNetworkingQuiz,
  'vercel-edge-functions': generateVercelEdgeFunctionsQuiz,
  'cloudflare-workers': generateCloudflareWorkersQuiz,
  'unity-fundamentals': generateUnityFundamentalsQuiz,
  'unity-scripting': generateUnityScriptingQuiz,
  'smart-iot-systems': generateSmartIotSystemsQuiz,
  'iot-security': generateIotSecurityQuiz,
  'performance-monitoring': generatePerformanceMonitoringQuiz,
  'load-testing': generateLoadTestingQuiz,
  'rpa-enterprise-architecture': generateRpaEnterpriseArchitectureQuiz,
  'robotics-rl-basics': generateRoboticsRlBasicsQuiz,
  'advanced-rl-algorithms': generateAdvancedRlAlgorithmsQuiz,
  'owasp-testing': generateOwaspTestingQuiz,
};

/**
 * Get quiz for a specific module
 */
export const getQuizForModule = (moduleId: string) => {
  const generator = MISSING_MODULE_QUIZZES[moduleId];
  return generator ? generator() : null;
};

/**
 * Get all module IDs that have quiz generators
 */
export const getAvailableModuleIds = (): string[] => {
  return Object.keys(MISSING_MODULE_QUIZZES);
};

/**
 * Check if a module has a quiz generator
 */
export const hasQuizGenerator = (moduleId: string): boolean => {
  return moduleId in MISSING_MODULE_QUIZZES;
};
